export class ViewModelFromPascalCaseValueConverter {
    toView(value: string): string {
        if (value === undefined || value === null) {
            return null;
        }
        const str = value.replace(/\s+/g, '');
        return str.split(/(?=[A-Z])/).join("-").toLowerCase();
    }
}